import { combineReducers } from 'redux';

import { reducer as list } from './list';
import { reducer as create } from './create';
import { reducer as update } from './update';
import { reducer as remove } from './remove';
import { reducer as tabs } from './tabs';
import { reducer as ui } from './ui';

export default combineReducers({
  list,
  create,
  update,
  remove,
  tabs,
  ui,
});
